<template>
  <div class="pull-down-wrapper">
    <div v-if="multiple" class="input-wrap" @click="handleSelectorOpen">
      <div class="selected" ref="staff-pull-down-selected">
        <div
          class="item"
          v-for="(item, index) in selectedList"
          :key="item.staff_id"
        >
          {{ item.name }}
          <i
            class="el-icon-error selected-close-icon"
            @click="deleteSelected(index, item.staff_id)"
          ></i>
        </div>
      </div>
      <div class="search">
        <el-input
          v-model="searchData.keyword"
          @focus="handleSearchFocus"
          @input="handleSearchChange"
          :placeholder="selectedList.length === 0 ? '请输入' : ''"
        ></el-input>
      </div>
    </div>
    <div v-else class="input-wrap" @click="handleSelectorOpen">
      <div class="search">
        <el-input
          v-model="searchData.keyword"
          @focus="handleSearchFocus"
          @input="handleSearchChange"
          placeholder="请输入"
          clearable
        ></el-input>
      </div>
    </div>
    <div
      class="selector-shadow"
      v-show="selectorVisible"
      @click="handleShadowClose"
    ></div>
    <div
      class="selector-wrap"
      v-show="selectorVisible"
      :style="`left:${pulldownX}px;top:${pulldownY}px;`"
    >
      <span class="arrow"></span>
      <div class="tabs">
        <div
          class="tab"
          :class="{ active: activeTab === 'onJob' }"
          @click="activeTab = 'onJob'"
        >
          在职员工
        </div>
        <div
          class="tab"
          :class="{ active: activeTab === 'depart' }"
          @click="activeTab = 'depart'"
        >
          离职员工
        </div>
      </div>
      <div class="list" v-show="activeTab === 'onJob'">
        <div
          class="item"
          v-for="(item, index) in onJobList"
          :class="{ selected: item.selected }"
          :key="item.staff_id"
          @click="handleSelect(item, index)"
        >
          {{ item.name }}<i class="el-icon-check"></i>
        </div>
        <div class="no-data" v-show="onJobList.length === 0">暂无数据</div>
      </div>
      <div class="list" v-show="activeTab === 'depart'">
        <div
          class="item"
          v-for="(item, index) in departList"
          :class="{ selected: item.selected }"
          :key="item.staff_id"
          @click="handleSelect(item, index)"
        >
          {{ item.name }}<i class="el-icon-check"></i>
        </div>
        <div class="no-data" v-show="departList.length === 0">暂无数据</div>
      </div>
    </div>
  </div>
</template>
<script>
import { staffList } from "@/api/globalSearch";
export default {
  props: ["defaultSelected", "originId", "jobIds", "multiple"],
  data() {
    return {
      selectedList: [], // 多选的展示
      searchData: {
        keyword: "",
      },
      cacheData: {
        keyword: "",
      },
      activeTab: "onJob",
      onJobList: [],
      departList: [],
      selectorVisible: false,
      pulldownX: 0,
      pulldownY: 0,
    };
  },
  computed: {
    selectedIds() {
      return this.selectedList.map((item) => {
        return item.staff_id;
      });
    },
  },
  watch: {
    defaultSelected(n) {
      this.setDefaultSelected(n);
    },
  },
  created() {
    if (this.defaultSelected && this.defaultSelected.length > 0) {
      this.setDefaultSelected(this.defaultSelected);
    }
  },
  methods: {
    setDefaultSelected(arr) {
      if (arr) {
        this.selectedList = arr;
        if (!this.multiple && arr[0]) {
          this.searchData.keyword = arr[0].name;
        } else {
          this.searchData.keyword = "";
        }
      } else {
        this.selectedList = [];
        this.searchData.keyword = "";
      }
    },
    handleSelectorOpen(e) {
      // input focus之后展开下拉，过滤删除点击事件
      if (e.target && e.target.nodeName !== "I") {
        const selectedEl = this.$refs["staff-pull-down-selected"];
        this.pulldownX =
          e.pageX - e.offsetX - (selectedEl ? selectedEl.clientWidth : 0);
        this.pulldownY = e.pageY - e.offsetY + 42;
        this.selectorVisible = true;
      } else if (e.target.className.indexOf("selected-close-icon") < 0) {
        // 单选模式下的清除按钮
        this.searchData.keyword = "";
        this.$emit("update:originId", "");
        this.$emit("update:defaultSelected", []);
        this.$emit("change");
      }
    },
    handleSearch(keyword) {
      staffList({
        page: 1,
        page_size: 50,
        key_word: keyword || "",
        status: 1,
        job_ids: this.jobIds || [],
      }).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((item) => {
            item.selected = this.selectedIds.indexOf(item.staff_id) >= 0;
          });
          this.onJobList = res.data.list;
        }
      });
      staffList({
        page: 1,
        page_size: 50,
        key_word: keyword,
        status: 2,
        job_ids: this.jobIds || [],
      }).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((item) => {
            item.selected = this.selectedIds.indexOf(item.staff_id) >= 0;
          });
          this.departList = res.data.list;
        }
      });
    },
    handleSearchFocus() {
      this.searchData.keyword = "";
      this.handleSearch(this.searchData.keyword);
    },
    handleSearchChange(v) {
      this.handleSearch(v);
    },
    handleSelect(data, index) {
      if (data.selected) {
        // 取消选中
        if (this.activeTab === "onJob") {
          this.onJobList[index].selected = false;
        } else {
          this.departList[index].selected = false;
        }
        const i = this.selectedList.findIndex((item) => {
          return item.staff_id === data.staff_id;
        });
        this.selectedList.splice(i, 1);
      } else {
        // 选中
        if (this.activeTab === "onJob") {
          if (!this.multiple) {
            this.onJobList.map((item) => {
              item.selected = false;
            });
          }
          this.onJobList[index].selected = true;
        } else {
          if (!this.multiple) {
            this.departList.map((item) => {
              item.selected = false;
            });
          }
          this.departList[index].selected = true;
        }
        if (this.multiple) {
          this.selectedList.push(data);
        } else {
          this.selectedList = [data];
          this.handleShadowClose();
        }
      }
      if (this.multiple) {
        this.$emit("update:originId", this.selectedIds);
      } else {
        this.$emit("update:originId", this.selectedIds[0]);
      }
      this.$emit("update:defaultSelected", this.selectedList);
      this.$emit("change");
    },
    deleteSelected(i, id) {
      // 多选点击删除
      const j = this.onJobList.findIndex((item) => {
        return item.staff_id === id;
      });
      const k = this.departList.findIndex((item) => {
        return item.staff_id === id;
      });
      if (j >= 0) {
        this.onJobList[j].selected = false;
      }
      if (k >= 0) {
        this.departList[k].selected = false;
      }
      this.selectedList.splice(i, 1);
      if (this.multiple) {
        this.$emit("update:originId", this.selectedIds);
      } else {
        this.$emit("update:originId", "");
      }
      this.$emit("update:defaultSelected", this.selectedList);
      this.$emit("change");
    },
    handleShadowClose() {
      this.selectorVisible = false;
      if (this.multiple) {
        this.searchData.keyword = "";
      } else {
        if (this.selectedList.length > 0) {
          this.searchData.keyword = this.selectedList[0].name;
        } else {
          this.searchData.keyword = "";
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pull-down-wrapper {
  position: relative;
  width: 100%;
  /deep/.input-wrap {
    display: flex;
    border: 1px solid #e7e8ea;
    border-radius: 4px;
    .selected {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .item {
        border: 1px solid #e7e8ea;
        border-radius: 4px;
        line-height: 18px;
        height: 18px;
        margin: 4px 0 0 6px;
        padding: 0 4px;
        display: inline-block;
        &:first-child {
          margin-right: 12px;
        }
        i {
          cursor: pointer;
          font-size: 14px;
          color: #e1e1e1;
          margin: 2px 0 0 6px;
          vertical-align: top;
        }
      }
    }
    .search {
      flex: 1;
      min-width: 80px;
      .el-input {
        .el-input__inner {
          border: none;
          line-height: 28px;
          height: 28px;
        }
      }
    }
  }
  .selector-shadow {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2000;
  }
  .selector-wrap {
    position: fixed;
    width: 180px;
    z-index: 2001;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    .arrow {
      left: 35px;
      top: -6px;
      border-top-width: 0;
      border-bottom-color: #ebeef5;
      border-width: 6px;
      filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
      position: absolute;
      display: block;
      width: 0;
      height: 0;
      border-color: transparent;
      border-style: solid;
      &::after {
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        content: " ";
        border-width: 6px;
        top: -5px;
        margin-left: -6px;
        border-top-width: 0;
        border-bottom-color: #fff;
      }
    }
    .tabs {
      display: flex;
      border-bottom: 1px solid #ebeef5;
      line-height: 40px;
      .tab {
        text-align: center;
        flex: 1;
        color: #5c5d5e;
        font-size: 13px;
        cursor: pointer;
        &.active {
          color: #07d1aa;
        }
      }
    }
    .list {
      padding: 5px 0;
      max-height: 200px;
      overflow: hidden auto;
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-track {
        width: 4px;
        background: none;
      }
      &::-webkit-scrollbar-thumb {
        width: 4px;
        background: #d8d8d8;
      }
      &::-webkit-scrollbar-button {
      }
      .item {
        padding: 0 20px;
        color: #5c5d5e;
        font-size: 12px;
        line-height: 28px;
        cursor: pointer;
        white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        i {
          display: none;
        }
        &:hover {
          background-color: #f5f7fa;
          color: #07d1aa;
        }
        &.selected {
          background-color: #f5f7fa;
          color: #07d1aa;
          i {
            display: inline-block;
          }
        }
      }
    }
    .no-data {
      text-align: center;
      color: #5c5d5e;
      font-size: 12px;
      line-height: 36px;
    }
  }
}
</style>
